export default function BhtLogo({ className = "h-8 w-8" }) {
  return (
    <svg viewBox="0 0 40 40" className={className} aria-hidden>
      <defs>
        <linearGradient id="bhtG" x1="0" x2="1" y1="0" y2="1">
          <stop offset="0" stopColor="#E4C77A" />
          <stop offset="1" stopColor="#C8A045" />
        </linearGradient>
      </defs>
      <rect x="1" y="1" width="38" height="38" rx="10" fill="#0A0F1A" stroke="url(#bhtG)" strokeWidth="1.5" />
      <path
        d="M11 10h9.5c3 0 5.2 1.9 5.2 4.6 0 1.8-1 3.2-2.5 3.9 2.1.7 3.4 2.4 3.4 4.7 0 3.1-2.4 5.1-6 5.1H11V10zm3.6 3.1v4.6h5.2c1.6 0 2.6-.9 2.6-2.3 0-1.4-1-2.3-2.6-2.3h-5.2zm0 7.5v4.6h5.6c1.8 0 2.9-.9 2.9-2.3 0-1.4-1.1-2.3-2.9-2.3h-5.6z"
        fill="url(#bhtG)"
      />
    </svg>
  );
}
